module.exports = __webpack_public_path__ + "images/category_lp/watch/store_images/3_70e8b53e51d0653d254ff56394e95614.png";